import {useDebugValue, useEffect} from 'react';

import {useInitialization} from '../../../hooks/useInitialization';
import {getSearchCookies} from '../../../utils/cookies';

import {getObjectValues} from '../../../utils/object';

function useDatesActions(data) {
    const {
        datesEvents: {
            onSettingsChange,
            onCurrentValuesChange,
            onLatestValuesChange
        },
        initialDatesSettings,
        changeDatesSettings,
        initialDatesValues,
        currentDatesValues,
        latestDatesValues,
        setCurrentDatesValuesDefault,
        setCurrentDatesValuesLatest,
        setLatestDatesValues,
        setAllDatesValuesDefault,
        setAllDatesValuesInitial,
        setSearchCookies
    } = data;

    const {
        isInitialized
    } = useInitialization();

    function setSettings(nextSettings) {
        changeDatesSettings(nextSettings);

        onSettingsChange(nextSettings);
    }

    function setSettingsInitial() {
        setSettings(initialDatesSettings);
    }

    function setDayData(dayData) {
        setSettings({
            dayData
        });
    }

    function setDayDataIds({startDayDataId, endDayDataId, selectedDayDataId}) {
        setSettings({
            startDayDataId,
            endDayDataId,
            selectedDayDataId
        });
    }

    function setIsOpen(isOpen) {
        setSettings({
            isOpen
        });
    }

    function setIsSelecting(isSelecting) {
        setSettings({
            isSelecting
        });
    }

    function setShowContinueButton(showContinueButton) {
        setSettings({
            showContinueButton
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(setSettingsInitial, [...getObjectValues(initialDatesSettings)]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(setAllDatesValuesInitial, [...getObjectValues(initialDatesValues)]);

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function triggerCurrentValuesChange() {
        if (isInitialized) {
            setSearchCookies(getSearchCookies());
            onCurrentValuesChange(currentDatesValues);
        }
    }, [...getObjectValues(currentDatesValues)]);
    /* eslint-enable react-hooks/exhaustive-deps */

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function triggerLatestValuesChange() {
        if (isInitialized) {
            onLatestValuesChange(latestDatesValues);
        }
    }, [...getObjectValues(latestDatesValues)]);
    /* eslint-enable react-hooks/exhaustive-deps */

    const result = {
        setDayData,
        setDayDataIds,
        setIsOpen,
        setIsSelecting,
        setShowContinueButton,
        setCurrentDatesValuesDefault,
        setCurrentDatesValuesLatest,
        setLatestDatesValues,
        setAllDatesValuesDefault
    };

    useDebugValue(result);

    return result;
}

export {useDatesActions};
